import baseLogger, { CONTEXTS } from 'widget/logger';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { TransportInterface } from 'widget/utils/transport/types';

export type PodcastShow = {
  customLinks?: Array<{
    [key: string]: string;
  }>;
  description?: string;
  editorialContentQuery?: Array<Array<string>>;
  follow?: boolean;
  id?: number;
  imageUrl?: string;
  isExternal?: boolean;
  lastUpdated?: number;
  showType?: 'serial' | 'episodic';
  slug?: string;
  socialMediaLinks?: Array<{
    [key: string]: string;
  }>;
  subtitle?: string;
  title?: string;
};

/*
 * Fetch podcast data given a podcast id
 */
export async function fetchPodcast({
  ampUrl = '',
  logger = baseLogger,
  podcastId,
  transport,
}: {
  ampUrl?: string;
  logger?: Logger;
  podcastId: number | null;
  transport: TransportInterface;
}): Promise<PodcastShow> {
  if (!podcastId) {
    const errObj = new HttpError(
      400,
      'Failed to fetch podcast info, podcast id missing.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  const [url, requestName] = createTaggedUrl`${{
    ampUrl,
  }}/api/v3/podcast/podcasts/${{
    podcastId: String(podcastId),
  }}`;

  const { data } = await transport.get(url, { params: { requestName } });
  return data;
}
